
















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { getCategoryLink } from '@shared/helpers/category/getCategoryLink';
import { ISearchCategoryFilter } from '@shared/types/search';
import { BaseList, BaseListItem } from '@shared/ui';

export default defineComponent({
  name: 'SearchResultsCategories',
  components: {
    BaseList,
    BaseListItem,
  },
  props: {
    categories: {
      type: Array as PropType<ISearchCategoryFilter[]>,
      required: true,
    },
  },
  methods: {
    getCategoryLink,
  },
});
